@file:Suppress("NonAsciiCharacters", "FunctionName", "ObjectPropertyName")

package it.neckar.lizergy.model.customer

import it.neckar.lizergy.model.customer.Customer.CustomerId
import it.neckar.uuid.randomUuid4
import kotlin.uuid.Uuid


object CustomerExample {
  fun empty(uuid: Uuid = randomUuid4()): Customer = Customer(
    id = CustomerId(uuid),
    firstName = "",
    lastName = "",
  )

  val PeterMüllerNoAddress: Customer = Customer(
    id = CustomerId(Uuid.parse("ab0c262d-fa24-4c71-a2be-e0f8ce825b4b")),
    firstName = "Peter",
    lastName = "Müller",
  )

  val PeterMüller: Customer = Customer(
    id = CustomerId(Uuid.parse("b2fb2c9f-26c2-475b-9211-a57a55dc081b")),
    firstName = "Peter",
    lastName = "Müller",
    address = it.neckar.lizergy.model.customer.AddressExample.addresses.random(),
  )

  val LisaMüller: Customer = Customer(
    id = CustomerId(Uuid.parse("e7889ec6-7bac-4de5-8054-8296000c0ea8")),
    firstName = "Lisa",
    lastName = "Müller",
    email = "Lisa@testcompany.de",
    phone = "+49 000 000",
    address = it.neckar.lizergy.model.customer.AddressExample.neckarIT,
  )

  /**
   * Creates a customer with a random address and name
   */
  @Deprecated("The test will probably not be reproducible. Think about using a specific customer instead")
  fun random(): Customer {
    val randomCustomers = listOf(
      PeterMüller,
      LisaMüller
    )
    return randomCustomers.random()
  }
}


val Customer.Companion.Example: CustomerExample
  get() = CustomerExample
